import React from 'react';
import StyledTooltip from '../../../../../../common/StyledToolTip';
import { getPriorityPickupIcon } from '../../../utils/pickupIcon';
import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
  iconsContainer: {
    display: 'flex',
    alignItems: 'center',
    height: '100%'
  },
  label:{
    paddingLeft: 4
  },
  iconStyle:{
    color: theme.iconColor
  }
});

const PriorityRenderer = (props) => {
  return props.value?.length ? (
    <div className={props.classes.iconsContainer}>
      { props.variant === "tooltip" ?  (
      <StyledTooltip title={props.value}>{getPriorityPickupIcon({className: props.classes.iconStyle})}</StyledTooltip>
      ) : (
        <>
        {getPriorityPickupIcon()}
        <label className={props.classes.label}>{props.value}</label>
        </>
      )}
    </div>
  ) : null;
};

export default withStyles(styles)(PriorityRenderer);
